import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';

const Footer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(12, 12, 12, 12)};
  align-items: center;
  margin: ${({ theme }) => `0 ${theme.constants.lateralSpace}`};
  > *:first-child {
    margin: ${({ theme }) => theme.spacing(0, 8, 0, 0)};
  }
`;

function Buttons({ acceptLabel, cancelLabel, onClose, onAccept, hideOptions }) {
  if (!hideOptions)
    return (
      <Footer>
        <SimpleButton
          elementId="modal_button_accept"
          label={cancelLabel || 'Cancelar'}
          color={COLOR.SECONDARY}
          onClick={onClose}
          size={SIZE.MEDIUM}
        />
        <SimpleButton
          elementId="modal_button_cancel"
          label={acceptLabel || 'Aceptar'}
          color={COLOR.PRIMARY}
          onClick={onAccept}
          size={SIZE.MEDIUM}
        />
      </Footer>
    );
  return null;
}

Buttons.propTypes = {
  cancelLabel: PropTypes.string,
  acceptLabel: PropTypes.string,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  hideOptions: PropTypes.bool,
};

export default Buttons;
